<template>
  <!-- 桐鹰计划蓄势待发活动页 -->
  <div class="page-container">
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/20241012/p_01.jpg" />
      <img class="img" src="@/static/images/activityCenter/20241012/p_02.jpg" />
      <img class="img" src="@/static/images/activityCenter/20241012/p_03.jpg" />
      <img class="img" src="@/static/images/activityCenter/20241012/p_04.jpg" />
      <img class="btn" src="@/static/images/activityCenter/20241012/btn.png" @click="jumpForm" />
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },

  created() {
  },

  data() {
    return {
    };
  },

  methods: {
    jumpForm(){
      this.$router.push('/apps/activityCenter/okApp/20241012/form')
    }

  }
};
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  min-height: 100vh;
  background: #ffe8e0;
  padding-bottom: 200px;
  .container {
    position: relative;
    .img {
      width: 750px;
      display: block;
    }
    .btn {
      position: fixed;
      left: 50%;
      bottom: 50px;
      transform: translateX(-50%);
      width: 710px;
    }
  }
}
</style>
